<template>
	<v-app class="lightGrey">
		<Navbar/>
		<v-main color="lightGrey">
			<v-progress-linear
				:active="loading"
				:indeterminate="loading"
				absolute
				top
				:color="ada.pink"
			></v-progress-linear>
			<div class="routerContainer ma-sm-5 ma-md-10"
					 @mousemove="resetTimer"
					 @click="resetTimer"
					 @input="resetTimer">
				<transition name="fade" mode="out-in">
					<router-view/>
				</transition>
			</div>
			<LogInDialog v-model="showLoginDialogModel"></LogInDialog>
		</v-main>
		<Snackbar v-model="snackbar" :color="snackbar_type">
			<div>{{ snackbar_message }}</div>
		</Snackbar>
		<DeleteDialog v-model="showDeleteDialog" :loading="deleteLoading" :title="deleteData ? deleteData.title : null">
			<div>{{ deleteData ? deleteData.message : null }}</div>
		</DeleteDialog>
	</v-app>
</template>

<script>
import ada from './scss/ada_colors.scss';
import Navbar from "./components/Navbar";
import Snackbar from "./components/Snackbar";
import LogInDialog from "./views/LogInDialog";
import DeleteDialog from "./views/components/DeleteDialog";

export default {
	name: 'App',
	components: {DeleteDialog, LogInDialog, Snackbar, Navbar},
	data: () => ({
		snackbar: false,
		snackbar_type: 'success',
		snackbar_message: null,
		showLoginDialogModel: false,
		showDeleteDialog: false,
		deleteData: null,
		deleteLoading: false,
		inactivityInterval: null,
		inactivityTimer: 0,
		ada
	}),
	created() {
		window.addEventListener('scroll', this.resetTimer);
	},
	destroyed() {
		window.removeEventListener('scroll', this.resetTimer);
	},
	mounted() {
		if (this.getParameterByName('session')) {
			// eslint-disable-next-line no-undef
			sso.saveSsoUser();
			if (this.getParameterByName('mail_alias')) {
				// eslint-disable-next-line no-undef
				let user = sso.getSsoUser();
				user.mail_alias = this.getParameterByName('mail_alias');
				localStorage.setItem('ssoUser', JSON.stringify(user));
			}
			if (this.getParameterByName('redirect')) {
				window.location.href = this.getParameterByName('redirect');
			}
		} else {
			// eslint-disable-next-line no-undef
			sso.init({
				logoutEndpoint: "https://sso.adalliance.io/api/users/globalsession/logout"
			});
			// eslint-disable-next-line no-undef
			sso.saveSsoUser();
		}
		this.$root.$on('snackbar', this.activateSnackbar);
		this.$root.$on('snackbarOff', this.deactivateSnackbar);
		this.$root.$on('showDeleteDialog', this.openDeleteDialog);
		this.$root.$on('deleteLoading', this.updateDeleteLoading);
		this.startInactivityInterval();
	},
	computed: {
		loading() {
			return this.$store.state.loading;
		},
		errorMessage() {
			return this.$store.state.error;
		},
		errorCount() {
			return this.$store.state.errorCount;
		},
		showLoginDialog() {
			return this.$store.state.showLoginDialog;
		}
	},
	methods: {
		getParameterByName(name, url) {
			if (!url) url = window.location.href;
			// eslint-disable-next-line no-useless-escape
			name = name.replace(/[\[\]]/g, '\\$&');
			var regex = new RegExp('[?&]' + name + '(=([^&#]*)|&|#|$)'),
				results = regex.exec(url);
			if (!results) return null;
			if (!results[2]) return '';
			return decodeURIComponent(results[2].replace(/\+/g, ' '));
		},
		activateSnackbar(msg, type = 'success') {
			//if (error && this.showSaveChangesDialog) this.showSaveChangesDialog = false;
			this.snackbar = false;
			this.snackbar_type = type;
			let timeout = type === 'error' ? 400 : 150;
			setTimeout(() => {
				this.snackbar_message = msg;
				this.snackbar = true;
			}, timeout)
		},
		deactivateSnackbar() {
			this.snackbar = false;
		},
		openDeleteDialog(data) {
			this.deleteData = data;
			this.showDeleteDialog = true;
		},
		updateDeleteLoading(value) {
			this.deleteLoading = value;
		},
		startInactivityInterval() {
			this.inactivityInterval = setInterval(() => {
				this.inactivityTimer++;
			}, 1000);
		},
		resetTimer() {
			this.inactivityTimer = 0;
			if (this.inactivityInterval === null) {
				this.startInactivityInterval();
				this.$root.$emit('active');
			}
		},
		checkAccessRights(to) {
			let role = this.$store.state.users.role;
			let router = this.$router.options.routes.find(x => x.name === to.name);
			return typeof (router.meta) === "undefined" ||
				typeof (router.meta.access) === "undefined" ||
				router.meta.access.includes(role);
		}
	},
	watch: {
		$route(newVal, oldVal) {
			this.resetTimer();
			if (newVal && oldVal && newVal.name !== oldVal.name) {
				this.$store.dispatch('display/siteStatus', {siteId: -1, override: false});
				if (!this.checkAccessRights(newVal)) this.$router.push({name: 'unauthorized'});
			}
			if (this.getParameterByName('session')) {
				// eslint-disable-next-line no-undef
				sso.saveSsoUser();
			}
		},
		errorCount() {
			console.error(this.errorMessage);
			this.activateSnackbar('Ein Fehler ist aufgetreten.', 'error');
		},
		showLoginDialog() {
			this.showLoginDialogModel = !!this.showLoginDialog;
		},
		inactivityTimer(n) {
			if (n === 30) { // 600s = 10min; 900s = 15min
				this.$root.$emit('inactive');
				clearInterval(this.inactivityInterval);
				this.inactivityInterval = null;
			}
		}

	}
};
</script>

<style lang="scss">
.lightGrey {
	background-color: $ada_lightGrey !Important;
}

.v-application {
	color: $ada_darkGrey !important;
}

.routerContainer {
	margin: 10px;
}

.fade-enter-active,
.fade-leave-active,
.fastfade-enter-active,
.fastfade-leave-active {
	transition-duration: 0.3s;
	transition-property: opacity;
	transition-timing-function: ease;
}

.fastfade-enter-active,
.fastfade-leave-active {
	transition-duration: 0.2s;
}

.fade-enter,
.fade-leave-active,
.fastfade-enter,
.fastfade-leave-active {
	opacity: 0
}

.ace_editor {
	border: 1px solid $ada_lightGrey;
}

html.hideScroll {
	overflow: hidden;
}

.noSiteSelected {
	display: flex;
	align-items: center;
	justify-content: center;
	height: 100%;
	font-size: 1.2em;
	color: $ada_darkGrey;
}
</style>
